import { useEffect, useState } from 'react';

function detectGoogleTranslate(): boolean {
    const html = document.documentElement;
    return (
        html.classList.contains('translated-ltr') ||
        html.classList.contains('translated-rtl') ||
        document.cookie.includes('googtrans=')
    );
}

export default function useIsGoogleTranslated(): boolean {
    const [isTranslated, setIsTranslated] = useState(detectGoogleTranslate);

    useEffect(() => {
        const check = () => {
            setIsTranslated(detectGoogleTranslate());
        };

        const observer = new MutationObserver(check);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class', 'lang'],
        });

        return () => observer.disconnect();
    }, []);

    return isTranslated;
}
